module.exports = __webpack_public_path__ + "img/T4-D-xs_23.a9c137e4.png";